import { render, staticRenderFns } from "./RepoSearchModal.vue?vue&type=template&id=409610c5&scoped=true"
import script from "./RepoSearchModal.vue?vue&type=script&lang=ts"
export * from "./RepoSearchModal.vue?vue&type=script&lang=ts"
import style0 from "./RepoSearchModal.vue?vue&type=style&index=0&id=409610c5&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409610c5",
  null
  
)

export default component.exports